module.exports = __webpack_public_path__ + "img/log-manager.6e285638.png";